import { SubmitButton } from 'components/common/buttons/SubmitButton';
import ErrorMessage from 'components/common/ErrorMessage';
import { Select } from 'components/common/Select';
import React, { useEffect, useState } from 'react';
import { Controller, useForm } from 'react-hook-form';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';

const reasonOpttions = [
    {
        label: "All Interpreters Unavailable",
        value: "All Interpreters Unavailable"
    },
    {
        label: "Limited Notice (less than 12 hours)",
        value: "Limited Notice (less than 12 hours)"
    },
    {
        label: "No Interpreters Hired with Language",
        value: "No Interpreters Hired with Language"
    },
    {
        label: "Short Notice (less than 2 hours)",
        value: "Short Notice (less than 2 hours)"
    }
]
function CouldNotCover({
    isOpen,
    onClose,
    onConfirm,
    appointmentId,
}) {

    const methods = useForm();
    const { control, formState: { errors }, handleSubmit } = methods;
    const [loader, setLoader] = useState(false);

    useEffect(() => {

        methods.reset({ cnc_reason: '' })

    }, [isOpen])



    return (
        <>
            <Modal isOpen={isOpen} toggle={onClose} centered className="modal-medium">
                <form action="" onSubmit={handleSubmit((data) => {
                    setLoader(true);
                    onConfirm(data, "cnc", () => {
                        setLoader(false);
                    })
                })}>
                    <ModalHeader className='header_modal align-items-center'>
                        <h5 className="modal-title_u">Do Not Cover Appointment</h5>
                    </ModalHeader>
                    <ModalBody className='modal_form_body'>
                        <div className='step_cards step_1'>
                            <h2>Appointment ID: {appointmentId}</h2>
                            <div className="row-primary">
                                <h2>Reason</h2>
                                <div className='w-100'>
                                    {/* Reason */}
                                    <div className="row-primary w-100">
                                        <Controller
                                            name="cnc_reason"
                                            control={control}
                                            rules={{
                                                required: "Please select a reason"
                                            }}
                                            render={({ field }) =>
                                                <>
                                                    <Select
                                                        name="cnc_reason"
                                                        options={reasonOpttions || []}
                                                        {...field}
                                                        value={field.value ? reasonOpttions?.find((opt) => field.value == opt.value) : null}
                                                        onChange={(value) => {
                                                            field.onChange(value);
                                                        }}
                                                    />


                                                    {errors?.cnc_reason?.message && (
                                                        <ErrorMessage
                                                            text={errors?.cnc_reason?.message}
                                                        />
                                                    )}
                                                </>
                                            }
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </ModalBody>
                    <ModalFooter>
                        <SubmitButton buttonType="submit" className={'yellow'} btnText="Donot Cover" loader={loader} />
                        <button className="table_delete" type='button' onClick={onClose}>Cancel</button>
                    </ModalFooter>
                </form>
            </Modal>
        </>
    );
}

export default CouldNotCover;